import React, {FC, useState} from 'react';

import path_up from 'assets/images/closeSelectIcon.svg';
import path_down from 'assets/images/openSelectIcon.svg';
import plusIcon from 'assets/icons/commons/plusIcon.svg';
import {setIsChatOpened} from "../../../redux/chat/reducer";
import {useDispatch} from "react-redux";

interface DataSourceProps {
  code: string;
  toggleIsDisclosed: (title: string) => void;
  isDisclosed: boolean;
}

export const RequestIntegration: FC<DataSourceProps> = ({
  code,
  toggleIsDisclosed,
  isDisclosed
}) => {

  const dispatch = useDispatch()

  const title = 'Другой'

  function openFormHandler(e: any) {
    e.stopPropagation()
    dispatch(setIsChatOpened(true))
  }

  return (
    <div
      className="border-[1.75px] p-2 mt-4 cursor-pointer rounded-[5px] select-none shadow-smooth"
      onClick={() => toggleIsDisclosed(code)}
    >
      <div className="flex max-h-11 rounded items-center">
        <div className="flex items-center min-w-36">
          <div className="text-xs flex flex-row text-[#1E293B] font-medium  text-sm">{title}</div>
        </div>
        <div className="flex mr-auto">

        </div>
        <div>
          <div>
            <img src={isDisclosed ? path_up : path_down} alt={''} />
          </div>
        </div>
      </div>
      {isDisclosed && (
        <div className={'flex items-center flex-col'}>
          <p className={'text-center text-[#94A3B8] text-[14px] mt-4 mb-3 w-5/6'}>
            Не нашли нужную Вам интеграцию? Мы можем дополнить функционал.
          </p>
          <button
              className={
                'flex justify-center items-center border-[2px] border-[rgba(15, 23, 42, 0.0392157)] px-[23.69px] py-[7px] rounded-[4px] text-[#2255A1]'
              }
              onClick={openFormHandler}
              type={'button'}
          >
            <img src={plusIcon} className={'mr-4'} alt="" />
            Запросить интеграцию
          </button>
        </div>
      )}
    </div>
  );
};
